"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BasisTheoryThreeDS = void 0;

var _common = require("./../common");

var _service = require("./../service");

class BasisTheoryThreeDS extends _service.BasisTheoryService {
  createSession(createRequest) {
    return this.client.post('/sessions', createRequest).then(_common.dataExtractor);
  }

  getSessionById(sessionId) {
    return this.client.get(`/sessions/${sessionId}`).then(_common.dataExtractor);
  }

  authenticateSession(sessionId, authenticateRequest) {
    return this.client.post(`/sessions/${sessionId}/authenticate`, authenticateRequest).then(_common.dataExtractor);
  }

  getChallengeResult(sessionId) {
    return this.client.get(`/sessions/${sessionId}/challenge-result`).then(_common.dataExtractor);
  }

}

exports.BasisTheoryThreeDS = BasisTheoryThreeDS;